(function () {
  var root = document.querySelector('[data-security-badge]');
  if (!root) return;

  var toggle = root.querySelector('[data-security-toggle]');
  var panel = root.querySelector('[data-security-panel]');
  var closeBtn = root.querySelector('[data-security-close]');
  if (!toggle || !panel) return;

  function setOpen(open) {
    panel.hidden = !open;
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  toggle.addEventListener('click', function () {
    setOpen(panel.hidden);
  });

  closeBtn?.addEventListener('click', function () {
    setOpen(false);
  });

  document.addEventListener('click', function (event) {
    if (!root.contains(event.target)) setOpen(false);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') setOpen(false);
  });
})();
